module.exports = __webpack_public_path__ + "img/icon-navigation-add.3f509d65.svg";